import { BRIEF_TYPE } from 'src/data/brief';
import { isBasicContentImproverTool, isRewriteGenerationTool } from 'src/data/generationTool';

import { ContentCanvas } from './views/ContentCanvas';
import { ContentContext } from './views/ContentContext';
import { ContentProduct } from './views/ContentProduct';

export const getContentComponent = (briefType, generationTool) => {
  if (isRewriteGenerationTool(generationTool) || isBasicContentImproverTool(generationTool)) {
    return ContentContext;
  }
  switch (briefType) {
    case BRIEF_TYPE.unifiedProduct:
      return ContentProduct;

    case BRIEF_TYPE.canvas:
      return ContentCanvas;

    default:
      throw new Error(`Unknown brief type to display content form: ${briefType}`);
  }
};
